export default __webpack_public_path__ + "static/media/footer.7087d344.png";